export default __webpack_public_path__ + "static/media/caroline.fa608000.png";